<template>
  <div class="inner">
    <div class="page_con">
      <div class="table_search">
        <div class="select">
          <select name="" id="">
            <option value="">제목</option>
          </select>
        </div>
        <div class="search_wrap">
          <div class="input">
            <input type="search" placeholder="검색" v-model="params.searchText" @keyup.13="fetchData(1)">
          </div>
          <button class="btn" @click="fetchData(1)">검색</button>
        </div>
      </div>
      <news-list :items="items" :page-info="pageInfo" @view="fnView" />
      <base-list-scroll-page
        v-bind:page="params.page"
        v-bind:currentIndex="currentIndex"
        v-bind:isActive="true"
        v-bind:listFunction="listFunction"
        v-on:finishFetch="fnFinishFetch"
      />
    </div>
    <top-button />
  </div>
</template>

<script>
import NewsList from '@/components/pages/news/list/index'
import TopButton from '@/components/pages/top/button'
export default {
  name: 'news-data-index',
  components: {TopButton, NewsList },
  data: function () {
    return {
      params: {
        limit: 10,
        page: 1,
        boardType: 3,
        listType: 2
      },
      currentIndex: 1,
      items: [],
      pageInfo: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function (page = 1) {
      this.params.page = page
      this.currentIndex++
      const res = await this.$BoardSvc.fetchBoardTypeList(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    listFunction: function ({ page }) {
      let params = Object.assign({}, this.params)
      params.page = page
      return this.$BoardSvc.fetchBoardTypeList(params)
    },
    fnFinishFetch: function(items, pageInfo) {
      this.items = items
      this.pageInfo = pageInfo
    },
    fnView: function(item) {
      this.$router.push({
        path: '/news/data/view',
        query: { dataNo: item.dataNo }
      })
    }
  }
}
</script>

<style scoped>

</style>
